import {
  DependencyList,
  EffectCallback,
  MutableRefObject,
  useEffect,
  useRef,
  useMemo
} from "react";
import { useLocation } from "react-router-dom";

import { getCountryAndLangaugeCodeAndDunsNumber } from "@/utils";

// https://stackoverflow.com/questions/28889826/how-to-set-focus-on-an-input-field-after-rendering/54159564#54159564
export const useFocus = <T extends HTMLElement>(): [MutableRefObject<T | null>, () => void] => {
  const reference = useRef<T>(null);

  const performFocus = () => {
    const current = reference.current;

    if (current !== null) {
      current.focus();
    }
  };

  return [reference, performFocus];
};

// https://stackoverflow.com/questions/53179075/with-useeffect-how-can-i-skip-applying-an-effect-upon-the-initial-render/53180013#53180013
export const useDidUpdateEffect = (effect: EffectCallback, deps: DependencyList): void => {
  const didMountReference = useRef(false);

  useEffect(() => {
    if (didMountReference.current) {
      return effect();
    }

    didMountReference.current = true;
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export const usePageURL = () => {
  const { pathname } = useLocation();

  const { languageCode, countryCode, dunsNumber } = useMemo(() => {
    return getCountryAndLangaugeCodeAndDunsNumber(pathname);
  }, [pathname]);

  return {
    countryCode,
    languageCode,
    currentPageUrl: pathname,
    dunsNumber
  }
}